import { graphql } from "../generated";

// `liked` is @authenticated, so it stays out of `GetShow`: the episode route
// loader runs that one before boot has registered the device user (see
// `useBookmark` / GetShowBookmarkState). Fetched from a component instead, for
// the whole show at once — one request serves every slide of the player.
// `likes` lives here and nowhere in `GetShow`: the Like / Unlike mutations write
// it back to `Episode:{id}`, and a field `GetShow` selected would hand the player
// a new `show` on every tap — `EpisodesPlayer` then remounts every slide and the
// episode restarts from 0.
export const GET_SHOW_LIKE_STATE = graphql(`
  query GetShowLikeState($showId: ID!) {
    show(id: $showId) {
      id
      episodes {
        id
        liked
        likes
      }
    }
  }
`);
